import requestFunctions from "../../functions/requestFunctions";


export const state = {
  TASKS_ITEM: {},
  TASKS_LIST: [],
  TASKS_TABLE_DATA: [],
  TASKS_LIST_DATA: [],
  TASKS_TOTAL_ROWS: 0
}

export const getters = {
  GET_TASKS_ITEM: (state) => {
    return state.TASKS_ITEM;
  },
  GET_TASKS_LIST: (state) => {
    return state.TASKS_LIST;
  },
  GET_TASKS_TABLE_DATA: (state) => {
    return state.TASKS_TABLE_DATA;
  },
  GET_TASKS_LIST_DATA: (state) => {
    return state.TASKS_LIST_DATA;
  },
  GET_TASKS_TOTAL_ROWS: (state) => {
    return state.TASKS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_TASKS_ITEM(state, item) {
    state.TASKS_ITEM = item;
  },

  UPDATE_TASKS_LIST(state, list) {
    
    state.TASKS_LIST = list.data;
    state.TASKS_TABLE_DATA = [];
    state.TASKS_LIST_DATA = [];

    state.TASKS_TOTAL_ROWS = list.total;
    list = list.data;

    let table_data = [];

    if(list.length > 0) {
      list.forEach(el => {

        let status =  el.status;

        if(status === 'created')   { status = 'Новая'         }
        if(status === 'preparing') { status = 'Подготовка'    }
        if(status === 'active')    { status = 'Активна'       }
        if(status === 'blocked')   { status = 'Заблокирована' }
        if(status === 'stopped')   { status = 'Остановлена'   }
        if(status === 'success')   { status = 'Завершена'     }
        if(status === 'canceled')  { status = 'Отменена'      }
        if(status === 'archive')   { status = 'В архиве'      }
        if(status === 'error')     { status = 'Ошибка'        }

        let ready = 0;

        if(el.status !== 'created'){
          if(el.qnt_calls === 0){
            ready = 0;
          } else {
            ready =  el.qnt_calls_finished / el.qnt_calls * 100;
          }
        }

        let user_data = '';
    
        if(el.profile_fullname !== null){
          user_data = el.profile_fullname;
        }
        
        if(el.user_phone !== null ){
          if(user_data !== ''){
            user_data = user_data + ', ';
          }
          user_data = user_data + el.user_phone;
        }

        table_data.push({
          'updated_at' : el.updated_at,
          'created_at' : el.created_at,
          'uuid' : el.uuid,
          'id' : el.id,
          'name' : el.name,
          'bot_name' : el.bot_name,
          'user_data': user_data,
          'account_number' : el.account_number,
          'skill_name' : el.skill_name,
          'ready' : Math.floor(ready) + '%',
          'status' : status
        });

        state.TASKS_LIST_DATA.push({
          id: el.id,
          uuid: el.uuid,
        });
      });

      state.TASKS_TABLE_DATA = table_data;

    }
  },
}

export const actions = {

  async FETCH_TASKS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tasks/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TASKS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_TASKS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/tasks';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TASKS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_TASKS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tasks';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TASKS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tasks/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TASKS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/tasks/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}